import {Api} from '@/core/api.js';
const api = new Api();

const state = {
    club: {},
    isUploading: false
}

const getters = {
    getClub (state) {
        return state.club;
    }
}

const actions = {

    loadClub: ({commit},params) => {
        return api.get('club/' + params.club_id ).then(function(response){
            return commit('setClub',response.data);
        });
    },

    loadClubEvent: ({commit},params) => {
        return api.get( 'club/' + params.club_id + '/event/' + params.event_id ).then(function(response){
            return commit('setClub', response.data);
        });
    },

    updateClub: ({commit},params) => {
        return api.post('club/' + params.club_id + '/update',params.input).then(function(response){
            return commit('setClub',response.data);
        });
    },

    uploadFiles( context, data ){        
        return new Promise((resolve, reject) => {
            var files = data.files;
            var uploaderFile = new Uploader();
            uploaderFile.upload(files[0], {},
                function (data) {
                    resolve(data);
                }, 
                function (e) {
                    resolve(e);
                }
            );
        });
    },

    upload( context, data ){
        var club_id = data.club_id;
        var club = {...data.input};
        var filesUpload = [];
        filesUpload.push(club.shield);
        context.commit( 'isUploading', true );
        return context.dispatch('uploadFiles', {files: filesUpload, club: club}).then(function(response){
            if(response){
                // save link from aws
                club.shield = response.Location;
                return api.post('club/' + club_id + '/update',club).then(function(response){
                    return response;
                });
            }
        });
    },

    addUniform({commit},params){
        return api.post('club/' + params.club_id + '/add-uniform',params.uniform).then(function(response){
            return response.data;
        })
    },

    updateUniform({commit},params){
        return api.post('club/' + params.club_id + '/update-uniform/' + params.uniform_id, params.uniform).then(function(response){
            return response.data;
        });
    },

    deleteUniform({commit},params){
        return api.get('club/' + params.club_id + '/delete-uniform/' + params.uniform_id).then(function(response){
            return response.data;
        });
    }

}

const mutations = {
    setClub(state, value) {
        state.club = value;
    },
    isUploading( state, value ){
        state.isUploading = false;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}